module.exports = __webpack_public_path__ + "img/mission.fce69676.png";